import { render, staticRenderFns } from "./two.vue?vue&type=template&id=ad847764&scoped=true"
import script from "./two.vue?vue&type=script&lang=js"
export * from "./two.vue?vue&type=script&lang=js"
import style0 from "./two.vue?vue&type=style&index=0&id=ad847764&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad847764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad847764')) {
      api.createRecord('ad847764', component.options)
    } else {
      api.reload('ad847764', component.options)
    }
    module.hot.accept("./two.vue?vue&type=template&id=ad847764&scoped=true", function () {
      api.rerender('ad847764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/two.vue"
export default component.exports